import { memo } from 'react';
// @mui
import { Box, BoxProps } from '@mui/material';

// ----------------------------------------------------------------------

function ListCCIcon({ ...other }: BoxProps) {

  return (
    <Box {...other}>
      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.5 15H0V7.5H7.5V15Z" fill="#322A29"/>
        <path d="M15 7.5H7.5V0H15V7.5Z" fill="#322A29"/>
      </svg>

    </Box>
  );
}

export default memo(ListCCIcon);
